<template>
  <section
    id="contact"
    class="container-fluid image-bg -marble_bg py-6 py-md-7"
  >
    <div class="container">
      <h2 :class="{ 'text-center': showAllInfo }">Contact Us</h2>
      <hr :class="{ 'center-hr': showAllInfo }" />
      <div v-if="showAllInfo" class="row justify-content-center mb-5">
        <div class="col-12 col-md-6 text-center">
          <p>
            <strong>CS Capital Advisors, LLC</strong>
            <br />300 Park Avenue, Suite 218<br/> New York, NY 10022
          </p>
        </div>
        <div class="col-12 col-md-6 text-center">
          <p>
            Office:
            <a href="tel:(212) 446-9177">(212) 446-9177</a>
            <br />Fax: (212) 446-9181
            <br />
            <a href="mailto:CSCA@cscapitaladvisors.com"
              >CSCA@cscapitaladvisors.com</a
            >
          </p>
        </div>
      </div>
      <div class="col-12">
        <form id="contact-form" @submit.prevent="processForm">
          <input id="name-field" v-model="name" />
          <input v-model="email" />
          <textarea v-model="message" rows="1"></textarea>
          <div class="text-center">
            <button type="submit">Send Message</button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    showAllInfo: Boolean
  },
  data() {
    return {
      name: "Name or Company Name",
      email: "Email Address",
      message: "How Can We Help?"
    };
  },
  methods: {
    processForm() {
      var linkString =
        "mailto:CSCA@cscapitaladvisors.com?subject=Website Inquiry from " +
        this.name +
        "&body=" +
        this.message;
      window.location.href = linkString;
      console.log({
        name: this.name,
        email: this.email,
        message: this.message
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  height: 400px; /* The height is 400 pixels */
  width: 100%; /* The width is the width of the web page */
}
hr {
  width: 100px;
  margin-left: 0;
  margin-bottom: 4rem;
  &.center-hr {
    margin-left: auto;
    margin-right: auto;
  }
}
input {
  width: 47%;
  margin-bottom: 4rem;
  background: transparent;
  border: none;
  border-bottom: 1px solid  #111d3c;
  font-weight: 300;
  outline: none;
  &:focus {
    border-bottom: 2px solid  #111d3c;
  }
  &#name-field {
    margin-right: 6%;
  }
}
textarea {
  width: 100%;
  font-weight: 300;
  background: transparent;
  border: none;
  border-bottom: 1px solid  #111d3c;
  outline: none;
  &:focus {
    border-bottom: 2px solid  #111d3c;
  }
}
button {
  margin-top: 4rem;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-size: 0.875rem;
  font-weight: 300;
  color: #ffffff;
  text-decoration: none;
  padding: 8px 28px;
  border-width: 1px;
  border-style: solid;
  border-color:  #111d3c;
  background-color:  #111d3c;
  transition: all 0.3s ease;
  &:hover {
    color: #dcb249;
    text-decoration: none;
  }
}
a {
  color:  #111d3c;
  transition: all 0.3s ease;
}
</style>
